<template>
  <div class="custom-text px-4">
    <CRow>
      <CCol>
        <div class="px-4 bg-transparent">
          <CRow>
            <CCol sm="12" md="3" lg="3" class="px-4 py-1 d-flex-col justify-content-around alin-items-center">
              <CCard class="py-3">
                <div style="height: 125px; width: 100%; border-radius: 15px; display: flex; justify-content: center; align-items: center; position: relative">
                  <div style="height: 65%; width: 65%; border: 3px rgba(218, 237, 255, 1) solid">
                    <ApplicantNewIcon className="fill-black-big" />
                  </div>
                  <div
                    style="position: absolute; top: 5%; right: 10%; width: 70px; height: 40px; border-radius: 5%; background-color: #ccc; display: flex; justify-content: center; align-items: center"
                  >
                    <div
                      style="
                        width: 100%;
                        height: 100%;
                        border-radius: 5%;
                        background-color: rgba(51, 119, 221, 1);
                        border: 2px rgba(51, 119, 221, 1) solid;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        font-size: 12px;
                      "
                    >
                      <h3 class="text-white mt-2">{{ pelamar + verif + lengkap }}</h3>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-1">
                  <CButton @click="$router.push('/pelamarKerja')" color="primary">
                    {{ $store.state.dashboard.newApplicant }}
                  </CButton>
                </div>
              </CCard>
            </CCol>
            <CCol>
              <div class="mb-2">
                <strong>{{ $store.state.dashboard.shortcut }}</strong>
              </div>
              <CRow class="mb-2">
                <CCol sm="12" md="6" lg="3">
                  <CCard @click="$router.push('/rekapAbsensi')" style="cursor: pointer; box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)" class="px-3 py-2 text-center">
                    {{ $store.state.dashboard.attendance }}
                  </CCard>
                </CCol>
                <CCol sm="12" md="6" lg="3">
                  <CCard @click="$router.push('/pengajuanLembur')" style="cursor: pointer; box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)" class="px-3 py-2 text-center">
                    {{ $store.state.dashboard.requestOvertime }}
                  </CCard>
                </CCol>
                <CCol sm="12" md="6" lg="3">
                  <CCard @click="$router.push('/pengajuanCuti')" style="cursor: pointer; box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)" class="px-3 py-2 text-center">
                    {{ $store.state.dashboard.requestTimeOff }}
                  </CCard>
                </CCol>
                <CCol sm="12" md="6" lg="3">
                  <CCard @click="$router.push('/dashboard')" style="cursor: pointer; box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2)" class="px-3 py-2 text-center">
                    {{ $store.state.dashboard.moreRequest }}
                  </CCard>
                </CCol>
              </CRow>

              <CRow>
                <CCol md="4">
                  <CCard class="px-2" style="background-color: rgba(218, 237, 255, 1); border-radius: 15px !important">
                    <CRow>
                      <CCol class="d-flex justify-content-end">
                        <div
                          style="
                            background-color: white;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 2px solid;
                            height: 40px;
                            width: 40px;
                            border-radius: 50%;
                            border-color: rgba(51, 119, 221, 1);
                          "
                        >
                          <ApplicationSentIcon className="fill-blue" />
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol class="text-32-39 text-center"
                        ><h2>{{ pelamar }}</h2></CCol
                      >
                    </CRow>
                    <CRow>
                      <CCol class="text-center"
                        ><h5>{{ $store.state.dashboard.applicationSent }}</h5></CCol
                      >
                    </CRow>
                  </CCard>
                </CCol>

                <CCol md="4">
                  <CCard class="px-2" style="background-color: rgba(234, 217, 255, 1); border-radius: 15px !important">
                    <CRow>
                      <CCol class="d-flex justify-content-end">
                        <div
                          style="
                            background-color: white;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 2px solid;
                            height: 40px;
                            width: 40px;
                            border-radius: 50%;
                            border-color: rgba(51, 119, 221, 1);
                          "
                        >
                          <AdministrationStageIcon className="fill-blue" />
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol class="text-32-39 text-center"
                        ><h2>{{ verif }}</h2></CCol
                      >
                    </CRow>
                    <CRow>
                      <CCol class="text-center"
                        ><h5>{{ $store.state.dashboard.administrationStage }}</h5></CCol
                      >
                    </CRow>
                  </CCard>
                </CCol>

                <CCol md="4">
                  <CCard class="px-2" style="background-color: rgba(219, 255, 229, 1); border-radius: 15px !important">
                    <CRow>
                      <CCol class="d-flex justify-content-end">
                        <div
                          style="
                            background-color: white;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 2px solid;
                            height: 40px;
                            width: 40px;
                            border-radius: 50%;
                            border-color: rgba(51, 119, 221, 1);
                          "
                        >
                          <SelectionStageIcon className="fill-blue" />
                        </div>
                      </CCol>
                    </CRow>
                    <CRow>
                      <CCol class="text-32-39 text-center"
                        ><h2>{{ lengkap }}</h2></CCol
                      >
                    </CRow>
                    <CRow>
                      <CCol class="text-center"
                        ><h5>{{ $store.state.dashboard.selectionStage }}</h5></CCol
                      >
                    </CRow>
                  </CCard>
                </CCol>
              </CRow>
            </CCol>
          </CRow>
        </div>
      </CCol>
    </CRow>

    <CRow>
      <CCol>
        <div>
          <div class="px-2">
            <h5>{{ $store.state.dashboard.employee }}</h5>
          </div>
        </div>
      </CCol>
    </CRow>

    <CRow class="d-flex gap-1">
      <CCol sm="12" md="6" lg="6" class="w-50">
        <CRow>
          <CCol sm="12" md="12" lg="12">
            <CCard>
              <div class="pt-2 px-4">
                <div class="d-flex justify-content-between mb-1 mt-1 px-1">
                  <div>
                    <h5>{{ $store.state.dashboard.employeeOverview }}</h5>
                  </div>
                  <div>
                    <h5>{{ $store.state.dashboard.today }}</h5>
                  </div>
                </div>
                <CRow>
                  <CCol>
                    <CCard class="p-2 text-center" style="background-color: rgba(219, 255, 229, 1); border-radius: 15px !important">
                      <CRow class="mb-1"
                        ><CCol><TotalEmployeeIcon className="fill-black" /></CCol
                      ></CRow>
                      <CRow>
                        <CCol
                          ><h5>
                            <strong>{{ totalKaryawan }}</strong>
                          </h5></CCol
                        >
                      </CRow>
                      <CRow>
                        <CCol
                          ><strong>{{ $store.state.dashboard.totalEmployee }}</strong></CCol
                        >
                      </CRow>
                    </CCard>
                  </CCol>

                  <CCol>
                    <CCard class="p-2 text-center" style="background-color: rgba(164, 210, 255, 0.4); border-radius: 15px !important">
                      <CRow class="mb-1"
                        ><CCol><EmployeOffIcon className="fill-black" /></CCol
                      ></CRow>
                      <CRow>
                        <CCol
                          ><h5><strong>0</strong></h5></CCol
                        >
                      </CRow>
                      <CRow>
                        <CCol
                          ><strong>{{ $store.state.dashboard.employeesOff }}</strong></CCol
                        >
                      </CRow>
                    </CCard>
                  </CCol>
                </CRow>
              </div>
            </CCard>
          </CCol>
        </CRow>

        <CRow>
          <CCol sm="12" md="12" lg="12">
            <CCard>
              <div class="pt-2 px-2">
                <div class="d-flex justify-content-between mb-1 mt-1 px-3">
                  <div>
                    <h5>{{ $store.state.dashboard.divisi }}</h5>
                  </div>
                  <div>
                    <CButton color="primary">{{ $store.state.dashboard.view }}</CButton>
                  </div>
                </div>
                <CRow>
                  <CCol>
                    <CDataTable :items="perDivisi" :fields="fields" :current-page="currentPage" :per-page="perPage" stacked="md" responsive show-empty small bordered striped hover :busy="tableBusy">
                      <template #actions="{ item }">
                        <td>
                          <b-button variant="info" v-c-tooltip.hover.click="'Detail'" @click="openDetail(item)">
                            <CIcon name="cil-info" />
                          </b-button>
                        </td>
                      </template>
                    </CDataTable>
                  </CCol>
                </CRow>
              </div>
            </CCard>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            <CCard class="px-2">
              <div class="d-flex justify-content-between mb-1 mt-1 px-1">
                <div>
                  <p>
                    <strong>{{ $store.state.dashboard.workforceFlow }}</strong>
                  </p>
                </div>
              </div>

              <CRow>
                <CCol md="6" sm="6" lg="6">
                  <CRow>
                    <CCol>
                      <CCard class="p-2 text-center" style="background-color: rgba(40, 167, 69, 0.5); border-radius: 15px !important">
                        <CRow class="mb-1"
                          ><CCol><KaryawanIcon icon="cilUserPlus" className="fill-black" size="xl" /></CCol
                        ></CRow>
                        <CRow>
                          <CCol
                            ><h5>
                              <strong>{{ inE }}</strong>
                            </h5>
                          </CCol>
                        </CRow>
                        <CRow>
                          <CCol
                            ><strong>{{ $store.state.dashboard.in }}</strong></CCol
                          >
                        </CRow>
                      </CCard>
                    </CCol>
                  </CRow>

                  <CRow>
                    <CCol>
                      <CCard class="p-2 text-center" style="background-color: rgba(255, 99, 132, 0.5); border-radius: 15px !important">
                        <CRow class="mb-1"
                          ><CCol><ContractIcon className="fill-black" /></CCol
                        ></CRow>
                        <CRow>
                          <CCol
                            ><h5>
                              <strong>{{ outE }}</strong>
                            </h5></CCol
                          >
                        </CRow>
                        <CRow>
                          <CCol
                            ><strong>{{ $store.state.dashboard.out }}</strong></CCol
                          >
                        </CRow>
                      </CCard>
                    </CCol>
                  </CRow>
                </CCol>
                <CCol>
                  <div style="max-height: 100px"><Chart3 :data="dataChartWorkflow" /></div>
                </CCol>
              </CRow>
            </CCard>
          </CCol>
        </CRow>

        <CRow>
          <CCol md="12">
            <div class="card p-3 mb-3">
              <h5 class="mb-3">{{ $store.state.dashboard.birthdayEmployee }}</h5>
              <div class="d-flex justify-content-between align-items-center mb-2" v-for="(birthday, index) in birthday" :key="index">
                <div class="d-flex align-items-center">
                  <img :src="birthday.image" class="rounded-circle me-2" style="width: 40px; height: 40px; object-fit: cover" />
                  <div>
                    <p class="mb-0">{{ birthday.namaKaryawan }}</p>
                    <small class="text-muted">
                      {{ $moment(birthday.tanggalLahirKaryawan).format("ll") }}
                    </small>
                  </div>
                </div>
                <!-- <CButton color="primary" size="sm">Say Happy Birthday</CButton> -->
              </div>
            </div>
          </CCol>
        </CRow>
      </CCol>

      <CCol sm="12" md="6" lg="6" class="w-50">
        <div>
          <div class="pt-2 px-4">
            <CRow>
              <CCol>
                <CCard @click="$router.push('/lowonganKerja')" class="p-3 text-center" style="cursor: pointer; height: 85px; border: 1px black solid; border-radius: 15px !important">
                  <CRow class="d-flex align-items-center h-100">
                    <CCol sm="3" md="3" lg="3" class="d-flex text-right h-100 align-items-center">
                      <div
                        style="
                          background-color: white;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          border: 2px solid;
                          height: 40px;
                          width: 40px;
                          border-radius: 50%;
                          border-color: rgba(51, 119, 221, 1);
                        "
                      >
                        <UploadVacancyIcon className="fill-blue" />
                      </div>
                    </CCol>
                    <CCol class="d-flex text-left h-100 align-items-center">
                      <h5 class="mt-2">{{ $store.state.dashboard.uploadVacancy }}</h5>
                    </CCol>
                  </CRow>
                </CCard>
              </CCol>

              <CCol>
                <CCard @click="$router.push('/announcement')" class="p-3 text-center" style="height: 85px; border: 1px black solid; border-radius: 15px !important">
                  <CRow class="d-flex align-items-center h-100">
                    <CCol sm="3" md="3" lg="3">
                      <div
                        style="
                          background-color: white;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          border: 2px solid;
                          height: 40px;
                          width: 40px;
                          border-radius: 50%;
                          border-color: rgba(51, 119, 221, 1);
                        "
                      >
                        <AnnounceIcon className="fill-blue" />
                      </div>
                    </CCol>
                    <CCol class="d-flex text-left h-100 align-items-center">
                      <h5 class="mt-2">{{ $store.state.dashboard.announcement }}</h5>
                    </CCol>
                  </CRow>
                </CCard>
              </CCol>
            </CRow>
          </div>
        </div>

        <div>
          <CCard class="px-2">
            <CRow>
              <CCol sm="12" md="6" lg="6">
                <div class="d-flex justify-content-between mb-1 mt-1 px-1">
                  <div>
                    <p>
                      <strong>{{ $store.state.dashboard.profileStrength }}</strong>
                    </p>
                  </div>
                </div>
                <CRow>
                  <CCol md="" sm="" lg="">
                    <CRow>
                      <CCol>
                        <CCard class="p-2 text-center" style="background-color: rgba(219, 255, 229, 1); border-radius: 15px !important">
                          <CRow class="mb-1"
                            ><CCol><PermanentIcon className="fill-black" /></CCol
                          ></CRow>
                          <CRow>
                            <CCol
                              ><h5>
                                <strong>{{ permanent }}</strong>
                              </h5></CCol
                            >
                          </CRow>
                          <CRow>
                            <CCol
                              ><strong>{{ $store.state.dashboard.permanent }}</strong></CCol
                            >
                          </CRow>
                        </CCard>
                      </CCol>
                    </CRow>

                    <CRow>
                      <CCol>
                        <CCard class="p-2 text-center" style="background-color: rgba(255, 250, 207, 1); border-radius: 15px !important">
                          <CRow class="mb-1"
                            ><CCol><ContractIcon className="fill-black" /></CCol
                          ></CRow>
                          <CRow>
                            <CCol
                              ><h5>
                                <strong>{{ contract }}</strong>
                              </h5></CCol
                            >
                          </CRow>
                          <CRow>
                            <CCol
                              ><strong>{{ $store.state.dashboard.contract }}</strong></CCol
                            >
                          </CRow>
                        </CCard>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol>
                    <div style="max-height: 100px"><Chart1 :data="dataChartStatus" /></div>
                  </CCol>
                </CRow>
              </CCol>

              <CCol sm="12" md="6" lg="6">
                <div class="d-flex justify-content-between mb-1 mt-1 px-1">
                  <div>
                    <p>
                      <strong>{{ $store.state.dashboard.genderDiversity }}</strong>
                    </p>
                  </div>
                </div>
                <CRow>
                  <CCol md="6" sm="6" lg="6">
                    <CRow>
                      <CCol>
                        <CCard class="p-2 text-center" style="background-color: rgba(164, 210, 255, 0.4); border-radius: 15px !important">
                          <CRow class="mb-1"
                            ><CCol><MensIcon className="fill-black" /></CCol
                          ></CRow>
                          <CRow>
                            <CCol
                              ><h5>
                                <strong>{{ men }}</strong>
                              </h5></CCol
                            >
                          </CRow>
                          <CRow>
                            <CCol
                              ><strong>{{ $store.state.dashboard.men }}</strong></CCol
                            >
                          </CRow>
                        </CCard>
                      </CCol>
                    </CRow>

                    <CRow>
                      <CCol>
                        <CCard class="p-2 text-center" style="background-color: rgba(234, 217, 255, 1); border-radius: 15px !important">
                          <CRow class="mb-1"
                            ><CCol><WomenIcon className="fill-black" /></CCol
                          ></CRow>
                          <CRow>
                            <CCol
                              ><h5>
                                <strong>{{ women }}</strong>
                              </h5></CCol
                            >
                          </CRow>
                          <CRow>
                            <CCol
                              ><strong>{{ $store.state.dashboard.women }}</strong></CCol
                            >
                          </CRow>
                        </CCard>
                      </CCol>
                    </CRow>
                  </CCol>
                  <CCol>
                    <div style="height: 100px"><Chart2 :data="dataChartGender" /></div>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCard>
          <CRow>
            <CCol md="12">
              <div class="card p-3 mb-3">
                <h5 class="mb-3">{{ $store.state.dashboard.expiredContract }}</h5>
                <div class="d-flex justify-content-between align-items-center mb-2" v-for="(contract, index) in expired" :key="index">
                  <!-- Left: employee info -->
                  <div class="d-flex align-items-center flex-grow-1">
                    <img :src="contract.image" class="rounded-circle me-2" style="width: 40px; height: 40px; object-fit: cover" />
                    <div>
                      <p class="mb-0">{{ contract.namaKaryawan }}</p>
                      <small class="text-muted">
                        {{ $moment(contract.jatuhTempoKontrak).format("ll") }}
                      </small>
                    </div>
                  </div>

                  <!-- Middle: nomor surat -->
                  <div class="contract-code text-start px-2 bg-primar">
                    <p class="mb-0">{{ contract.nomorSuratPerintah }}</p>
                  </div>

                  <!-- Right: button -->
                  <div class="ml-5 d-flex justify-content-end gap-2" style="min-width: 180px">
                    <button v-if="!contract?.penilianKinerja?.status" @click="$router.push('/assesmentKaryawan')" class="btn btn-sm btn-secondary">
                      {{ $store.state.dashboard.evaluation }}
                    </button>
                    <button @click="$router.push('/mutasi')" class="btn btn-sm btn-danger">
                      {{ $store.state.dashboard.newOffer }}
                    </button>
                  </div>
                </div>
              </div>
            </CCol>
          </CRow>
        </div>
      </CCol>
    </CRow>
    <Popup />

    <!-- Detail Modal -->
    <b-modal id="modal-detail" v-model="detail" size="xl" title="Detail Karyawan per Divisi" hide-footer centered>
      <div v-if="loading" class="text-center my-5">
        <b-spinner label="Loading..."></b-spinner>
      </div>

      <div v-else>
        <b-table :items="items" :fields="modalFields" striped hover bordered small> </b-table>

        <div class="text-right mt-3">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" @change="getDatas"></b-pagination>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Popup from "@/component/hcms/dashboard/modalAlert.vue";
import Chart1 from "./DashboardChartContract.vue";
import Chart2 from "./DashboardChartGender.vue";
import Chart3 from "./DashboardChartWorkForce.vue";
export default {
  components: {
    Popup,
    Chart1,
    Chart2,
    Chart3,
  },
  name: "DashboardHcms",
  data() {
    return {
      bday: null,
      pelamar: 0,
      verif: 0,
      lengkap: 0,
      karyawanWNA: 0,
      totalKaryawan: 0,
      men: 0,
      women: 0,
      permanent: 0,
      contract: 0,
      inE: 0,
      outE: 0,
      birthday: [],
      expired: [],
      perDivisi: [],
      detail: false,
      data: "",
      loading: false,
      items: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      modalFields: [
        { key: "no", label: "No", class: "text-center" },
        { key: "NIK", label: "NIK" },
        { key: "namaKaryawan", label: "Nama" },
        { key: "namaDivisi", label: "Divisi" },
        // { key: "namaMitra", label: "Mitra" },
      ],
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sorter: true,
          _style: "width: 1px;",
          _classes: "table-number text-center",
        },
        {
          key: "namaDivisi",
          label: "Divisi",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },
        {
          key: "totalKaryawan",
          label: "Total",
          sorter: true,
          sortDirection: "desc",
          _classes: "text-left",
        },

        {
          key: "actions",
          label: "Actions",
          _style: "width: 1px;",
          _classes: "table-option-2 text-center",
        },
      ],
      dataChartStatus: [],
      dataChartGender: [],
      dataChartWorkflow: [],
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filter2: null,
      filterOn2: [],
      tableBusy: false,
    };
  },
  created() {
    this.getData();
  },
  computed: {
    entriesaw() {
      return this.perDivisi.length != 0 && this.perDivisi ? this.perDivisi[0].no : 0;
    },
    entriesak() {
      return this.perDivisi.length != 0 && this.perDivisi ? this.perDivisi[this.perDivisi.length - 1].no : 0;
    },
    mitra_aktif() {
      return this.$store.state.mitra_aktif;
    },
    user_login() {
      return this.$store.state.login_data_user ? this.$store.state.login_data_user : null;
    },
    check_time() {
      let x = this.$moment("HH");
      let y = x >= 6 && x < 12 ? "Pagi" : x >= 12 && x <= 17 ? "Siang" : "Malam";
      return y;
    },
    copy() {
      const vm = this;
      const main = window.location.origin;
      const query = `?company=${vm.mitra_aktif.id}&kode=${vm.$store.state.kode_client}`;
      return {
        "lowongan kerja": `${main}/loker${query}`,
        "login lowongan kerja": `${main}/loginToken${query}`,
      };
    },
  },
  methods: {
    async openDetail(divisi) {
      this.filter = {
        ...this.filter,
        divisi: { masterDivisiId: divisi.masterDivisiId },
        mitra: null, // reset or keep as needed
      };
      this.detail = true;
      await this.getDatas();
    },

    async getDatas() {
      const vm = this;
      vm.loading = true;

      try {
        let response = await vm.$axios.post("dataKaryawan/filterDataKaryawanPerHalaman", {
          ...vm.filter,
          mitraId: vm.filter.mitra ? vm.filter.mitra.id : null,
          masterDivisiId: vm.filter.divisi ? vm.filter.divisi.masterDivisiId : null,
          halaman: vm.currentPage - 1,
          jumlah: vm.perPage,
        });

        if (response.data.status === 200) {
          vm.items = response.data.data.map((x, idx) => ({
            ...x,
            no: (vm.currentPage - 1) * vm.perPage + idx + 1,
            id: x.dataKaryawanId,
            namaMitra: x.namaMitra || "-",
            NIK: x.NIK || "-",
            namaDivisi: x.namaDivisi || "-",
            namaKaryawan: x.namaKaryawan || "-",
          }));
          vm.totalRows = Number(response.data.count);
        } else {
          vm.items = [];
          vm.totalRows = 0;
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        vm.loading = false;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onFiltered2(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async copyData(x) {
      const vm = this;
      // console.log(window.location.origin)
      await navigator.clipboard.writeText(vm.copy[x]);
      vm.$store.commit("set_alert", {
        variant: "success",
        msg: `Berhasil copy ${x}`,
        showing: true,
      });
    },
    getAvatar(avatar) {
      return avatar && avatar.trim() !== "" ? avatar : "https://picsum.photos/200";
    },
    async getData() {
      let vm = this;
      let listPelamar = await vm.$axios.get("postLoker/listByStatus/" + 0);
      vm.pelamar = listPelamar.data.data.length;

      let listVerif = await vm.$axios.get("postLoker/listByStatus/" + 1);
      vm.verif = listVerif.data.data.length;

      let listLengkap = await vm.$axios.get("postLoker/listByStatus/" + 2);
      vm.lengkap = listLengkap.data.data.length;

      let men = await vm.$axios.post("/dataKaryawan/filterDataKaryawanPerHalaman", {
        jenisKelamin: "Laki-laki",
        halaman: 0,
        jumlah: 10000,
      });
      vm.men = men.data.count;

      let women = await vm.$axios.post("/dataKaryawan/filterDataKaryawanPerHalaman", {
        jenisKelamin: "Perempuan",
        halaman: 0,
        jumlah: 10000,
      });
      vm.women = women.data.count;

      let permanent = await vm.$axios.post("/dataKaryawan/filterDataKaryawanPerHalaman", {
        statusPerjanjian: "1",
        halaman: 0,
        jumlah: 10000,
      });
      vm.permanent = permanent.data.count;

      let contract = await vm.$axios.post("/dataKaryawan/filterDataKaryawanPerHalaman", {
        statusPerjanjian: "0",
        halaman: 0,
        jumlah: 10000,
      });
      vm.contract = contract.data.count;

      let expired = await vm.$axios("/dataKaryawan/notifHabisKontrak");
      vm.expired = expired.data.data;

      let birthday = await vm.$axios("/dataKaryawan/notifUlangTahun");
      vm.birthday = birthday.data.data;

      let totalKaryawan = await vm.$axios.get("dataKaryawan/totalKaryawan");
      vm.totalKaryawan = totalKaryawan.data.data[0].totalKaryawan;

      let perDivisi = await vm.$axios.get("dataKaryawan/listTotalKaryawanPerDivisi");
      vm.perDivisi = perDivisi.data.data.map((x, idx) => {
        return {
          no: idx + 1,
          ...x,
        };
      });

      let inE = await vm.$axios.post("dataKaryawan/listKaryawanMasuk", {
        tahun: vm.$moment().format("YYYY"),
      });
      vm.inE = inE.data.data.length;

      let outE = await vm.$axios.post("dataKaryawan/listKaryawanKeluar", {
        tahun: vm.$moment().format("YYYY"),
      });
      vm.outE = outE.data.data.length;

      vm.dataChartStatus = [vm.permanent, vm.contract];
      vm.dataChartGender = [vm.men, vm.women];
      vm.dataChartWorkflow = [vm.inE, vm.outE];
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
  },
};
</script>

<style scoped>
.custom-text {
  font-family: "Manrope", sans-serif;
  letter-spacing: 0.7px;
}

.shortcut-button {
  height: 56px;
}

.text-32-39 {
  font-size: 32px !important;
  line-height: 39px !important;
}

.blue-circle {
  border-color: rgba(51, 119, 221, 1);
  border: 3px solid;
  border-radius: 50%;
  height: 40px;
  width: 40px;
}

.fill-blue {
  fill: rgba(51, 119, 221, 1);
  height: 28px;
  width: 28px;
  /* stroke: white; */
}

.fill-black {
  fill: black;
  height: 30px;
  width: 30px;
  /* stroke: white; */
}

.fill-black-big {
  fill: black;
  height: 100px;
  width: 170px;
  /* stroke: white; */
}

.contract-code {
  min-width: 180px; /* adjust as needed */
  max-width: 180px;
  white-space: nowrap;
}
</style>
